const packagesRouter = [
    {
        path: "list-package",
        name: "packages",
        component: () => import("@/views/admin/packages"),
        default: true,
        meta: {
            model: "packages",
            // requiresAuth: true,
        },
    },
    {
        path: "list-package/add",
        name: "addPackages",
        component: () => import("@/views/admin/packages/function"),
        default: true,
        meta: {
            model: "packages",
            // requiresAuth: true,
        },
    },
    {
        path: "list-package/edit/:id",
        name: "editPackages",
        component: () => import("@/views/admin/packages/function"),
        default: true,
        meta: {
            model: "packages",
            // requiresAuth: true,
        },
    },
];
export default packagesRouter;